import { getLang, urlHelper } from "helpers/themeHelpers";

export enum EnumPostRef {
  HOME = "HOME",
  SERP = "SERP",
  MID = "MID",
  SHOP = "SHOP",
  SIMILAR = "SIMILAR",
  RECOMMENDED = "RECOMMENDED",
  TAGS_DETAILS = "TAGS_DETAILS"
}

export enum EnumPostType{
  RECENTLY_VIEWED = "RECENTLY-VIEWED",
  RECOMMENDED = "RECOMMENDED"
}

export const linkToPostView = (post, ref?: EnumPostRef) => {
  const locale = getLang();
  switch (post?.view_type) {
    case "JobPoster":
      return `/${locale}/job-posters/${post?.id}${ref ?'#ref='+ref :''}`;
    case "JobSeeker":
      return `/${locale}/job-seekers/${post?.cv_id}${ref ?'#ref='+ref :''}`;
    default:
      if (post?.postUrl || post?.post_url) {
        let url = `/${locale}/search${
          (post?.postUrl || post?.post_url).split("/search")[1]
        }`;
        if (ref) {
          url += `#ref=${ref}`;
        }
        return url;
      }
      return `/${locale}/search/${post?.id}`;
  }
};

export const addQueryParamsToLinkPostView = (linkToPostViewCallback , post, ref?: EnumPostRef , postId:number | string | string[]= null ,postType =null) => {
  const url = linkToPostViewCallback(post , ref)
  let queryParam;
  if(postType){
    queryParam = `${postType}-${ref}`
  }else{
    queryParam = `${ref}-${postId}`
  }
  const urlRef = url.split("#");
  return `${urlRef[0]}?ref=${queryParam}${urlRef[1] && '#'+urlRef[1]}`;
};

export const seoUrlWords = (keywords:string) => {
  keywords = keywords.toLowerCase();
  // Step 1: Replace '&' with 'and'
  keywords = keywords.replace(/&/g, "and");
  // Step 2: Replace characters that are not letters, digits, Arabic characters, or underscores with spaces
  keywords = keywords.replace(/[^a-zA-Z0-9ّ\u0600-\u06FF_]/g, " ");
  // Step 3: Replace spaces with '-'
  keywords = keywords.replace(/\s+/g, "-");
  // Step 4: Trim '-' from the beginning and end of the string
  keywords = keywords.replace(/^-+|-+$/g, "");
  return keywords;
};

export const linkToCarMakeSpecsPage = (make, pageNumber) => {
  const locale = getLang();
  const pageName =
    locale === "ar" ? `اسعار-مواصفات-السيارات` : `cars-prices-specs`;
  return `/${locale}/${pageName}/${urlHelper(make)}/?page=${pageNumber}`;
};
